import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../common/LoadingSpinner";

/**
 * Nagłówek z informacją o trybie i akcjami
 */
const ApplicationHeader = ({ mode, chamberName, loading, onAssign }) => {
  const navigate = useNavigate();
  const [isAssigning, setIsAssigning] = useState(false);

  const handleCreateApplication = () => {
    navigate("/application/add", { replace: true });
  };

  const handleGetApplication = async () => {
    setIsAssigning(true);
    try {
      await onAssign();
    } finally {
      setIsAssigning(false);
    }
  };

  return (
    <>
      {mode === "user" && (
        <div className="d-flex flex-row mb-2">
          <div>W tym widoku możesz śledzić postęp obsługi swoich wniosków.</div>
          <div className="ms-auto">
            <button
              className="btn btn-primary w11 h2"
              onClick={handleCreateApplication}
            >
              Utwórz wniosek
            </button>
          </div>
        </div>
      )}

      {mode === "operator" && (
        <div className="d-flex flex-row mb-2">
          <div>
            W tym widoku możesz śledzić postęp obsługi wniosków, które zostały
            Ci przypisane.
          </div>
          <div className="ms-auto">
            {loading || isAssigning ? (
              <button className="btn btn-primary w11 h2" disabled>
                <LoadingSpinner text="Pobieranie wniosku" />
              </button>
            ) : (
              <button
                className="btn btn-primary w11 h2"
                onClick={handleGetApplication}
              >
                Pobierz wniosek
              </button>
            )}
          </div>
        </div>
      )}

      {mode === "coordinator" && (
        <div className="d-flex flex-row mb-1">
          <div>
            W tym widoku możesz zarządzać wnioskami przypisanymi do izby:{" "}
            <strong>{chamberName}</strong>.
          </div>
        </div>
      )}

      {mode === "shipping" && (
        <div className="d-flex flex-row mb-1">
          <div>
            W tym widoku możesz zarządzać wysyłką wniosków przypisanych do izby:{" "}
            <strong>{chamberName}</strong>.
          </div>
        </div>
      )}
    </>
  );
};

export default ApplicationHeader;
